import PaginationRequest from '@/common/pagination/entities/pagination-request'
import { LogwoodPackageState } from '@/logwood/models/logwood-package-state'

export default class LogwoodPackageFilter {
  public state: LogwoodPackageState = LogwoodPackageState.OuterBearing
  public location = 1
  public paging: PaginationRequest = new PaginationRequest()
}